module.exports = __webpack_public_path__ + "static/media/BusinessAnalyst.974e282d.JPG";